import { Button, Center, Flex, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";

import { NumOfBsd } from "CommonData";
import SRD_Form from "components/Form/index";
import { getBsdList, getChList } from "pages/Admin/Device/apis/adminDeviceApis";
import { deleteAlarmItem, updAlarmItem } from "pages/SMS/ItemSetting/apis/itemSettingApis";

import { currentBsdState } from "pages/Login/atom/currentBsdState";
import { userGroupState } from "pages/Login/atom/userGroupState";
import { userLevelState } from "pages/Login/atom/userLevelState";
import { userState } from "pages/Login/atom/userState";
import { bsdNmState, currentBsdListState, smsItemUserState } from "pages/atom/globalState";


function ItemSettingEditForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { bsd_id, chnnl_no, sms_ment, id,
    operator, set_value, tx_count_, tx_period, alarm_yn } = location.state || {};

  const [user, setUser] = useRecoilState(userState);
  const userLevel = useRecoilValue(userLevelState);
  const userGroup = useRecoilValue(userGroupState);

  const [bsdListState, setBsdListState] = useRecoilState(currentBsdListState);
  const [bsdState, setBsdState] = useRecoilState(currentBsdState);
  const [bsdNm, setBsdNm] = useRecoilState(bsdNmState);
  const [chList, setChList] = useState([]);
  const [ch, setCh] = useState();
  const [defaultValues, setDefaultValues] = useState();
  const [itemUserState, setItemUserState] = useRecoilState(smsItemUserState);

  const bsd_sttus_id = itemUserState.bsd_sttus_id;
  const chnnl_nm = itemUserState.chnnl_nm;
  const item_id = itemUserState.id;

  useEffect(() => { 
    console.log("userGroup > ", userGroup);
    if (userGroup !== 'undefined') {
    getBsdList(NumOfBsd, 1, userGroup).then((res) => {
      if (res && Array.isArray(res)) {
        const filteredList = (res || []).filter((item) => item.group_id === userGroup);
        const formattedBsdList = (filteredList || []).map((item) => ({
          value: item.bsd_id,
          label: item.bsd_nm,
        }));
        setBsdListState(formattedBsdList);
        if (formattedBsdList.length === 0) {
          console.log("선택할 장치 항목이 없습니다.");
        }
      } else {
        console.log("장치 리스트가 로드되지 않았습니다.");
        setBsdListState([]); // 데이터가 없을 경우 빈 배열로 설정
      }
    });
    }
  }, []);
  
  useEffect(() => { 
    console.log("bsdState > ", bsdState);
    if (bsdState) {
      getChList(bsdState).then((res) => {
        if (res && Array.isArray(res)) {
          const filteredList = (res || []).filter((item) => item.bsd_id === bsdState);
          const formattedChList = (filteredList || []).map((item) => ({
            value: item.chnnl_no,
            label: item.chnnl_nm,
          }));
          setChList(formattedChList);
          // setLoading(false);
          console.log("formattedChList :", formattedChList);
          if (formattedChList.length === 0) {
            console.log("선택할 채널 항목이 없습니다.");
          }
        } else {
        console.log("채널 리스트가 로드되지 않았습니다.");
        setChList([]); // 데이터가 없을 경우 빈 배열로 설정
      }
      });
    } else {
      setChList([]); // bsd 또는 group이 선택되지 않았을 때 chList를 비웁니다.
    }
  }, [bsdState]);

  const fields = [
    {
      key: "id",
      name: "구분",
      type: "text",
      defaultValue: id,   // 같은 채널, 다른 메세지 처리위해
      hidden: true,  // id 값은 화면에 표시되지 않도록 설정
    },
    {
      key: "bsd_nm",
      name: "선택된 분사 장치",
      type: "text",
      defaultValue: bsdListState.find(item => item.value === bsdState)?.label || '기본값',
      onChange: (value) => setBsdNm(value),
    },
    {
      key: "chnnl_nm",
      name: "알람 항목",
      type: "text",
      defaultValue: chnnl_nm,   // 선택한 채널명 변경 금지
    },
    {
      key: "sms_ment",
      name: "알람 메세지",
      type: "text",
      defaultValue: sms_ment,
    },
    {
      key: "operator",
      name: "조건항목",
      type: "select",
      options: ["=", ">", "<", ">=", "<="],
      defaultValue: operator,
    },
    {
      key: "set_value",
      name: "설정값",
      type: "text",
      defaultValue: set_value,
    },
    {
      key: "tx_period",
      name: "재전송주기(분)",
      type: "text",
      defaultValue: tx_period,
    },
    {
      key: "alarm_yn",
      name: "알람 사용 여부",
      type: "radio_select",
        options: [
          { value: "Y", label: "Yes" },
          { value: "N", label: "No" },
        ],
        defaultValue: alarm_yn,
      },
  ];

  
  const updateAlarmItem = async (e) => {
    // // bsd_id와 chnnl_no로 bsd_sttus_id 찾기
    // const res = await getChList(bsdState);
    // const currentCh = (res || []).find(item => item.chnnl_nm === e.chnnl_nm); // 수정된 부분
    // if (currentCh) { // currentCh 존재하는지 확인
        await updAlarmItem({
            ...e,
            // chnnl_no: currentCh.chnnl_no, // 수정된 부분
            // bsd_sttus_id,
            item_id,
        });
        navigate("/sms/item");
    // } else {
    //     console.error('채널을 찾을 수 없습니다.'); // 채널이 없을 경우 에러 처리
    // }
};

  const onSubmit = (e) => {
    console.log(e);
    console.log("itemUserState > ", itemUserState);
    modals.openConfirmModal({
      title: "수정",
      children: <Center>수정 하시겠습니까?</Center>,
      centered: true,
      zIndex: 2000,
      labels: { confirm: "예", cancel: "아니오" },
      onConfirm: () => {
        updateAlarmItem(e);
      },
    });
  };

  const onDelete = (e) => {
    modals.openConfirmModal({
      title: "삭제",
      centered: true,
      zIndex: 2000,
      children: (
        <Center>
          <Text>정말 삭제하시겠습니까? (삭제 후 복구불가)</Text>
        </Center>
      ),
      labels: { confirm: "삭제", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        deleteAlarmItem(id, bsd_sttus_id);
        navigate("/sms/item");
      },
    });
  };

  const SubmitButtons = () => {
    const handleCancel = () => {
      navigate("/sms/item", { state: { bsdState } });
    };
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Flex
          style={{
            width: "100%",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Button type="submit">수정</Button>
          <Button color="red" onClick={() => onDelete()}>
            삭제
          </Button>
          <Button type="button" onClick={handleCancel}>취소</Button>
        </Flex>
      </Center>
    );
  };

  return (
    <SRD_Form
      fields={fields}
      onSubmit={onSubmit}
      submitButton={<SubmitButtons />}
      defaultValues={defaultValues}
    />
  );
}

export default ItemSettingEditForm;
